import React from "react";
import { Row, Col } from "react-flexbox-grid";
import Masonry from "react-masonry-css";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { withRouter } from "react-router-dom";
import "./portfolio.scss";
import projectsInfo from "./projects.js";

//Components
import Title from "../ui-components/title/title";
import ProjectBox from "../ui-components/projectBox/projectBox";

class Portfolio extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      projects: projectsInfo,
      filterResult: null,
      pickedFilter: "all",
      filterType: "all",
      filterMenuActive: false,
      pickedFilterDropdown: "NEWEST",
      showModal: false,
      activeProjectImages: [],
      availableFilters: ["all", "furniture", "industry", "branding"],
      pickedTypeFilter: "all",
      pickedTagFilter: "all",
    };
  }
  //FILTER PORTFOLIO FUNCTION
  filterGallery = (target) => {
    const projectsArr = [...this.state.projects];

    // Primeiro, aplique o filtro do tipo (filterType)
    const filteredByType =
      this.state.filterType === "all"
        ? projectsArr
        : projectsArr.filter((project) => project.modelType === this.state.filterType);

    // Depois, aplique o filtro de tag (target)
    const result = target === "all" ? filteredByType : filteredByType.filter((project) => project.tag === target);

    this.setState({
      filterResult: result,
      pickedTagFilter: target,
    });
  };

  filterGalleryBytYPE = (target) => {
    const projectsArr = [...this.state.projects];
    const result = target === "all" ? projectsArr : projectsArr.filter((project) => project.modelType === target);

    const availableFilters = ["all", ...new Set(result.map((project) => project.tag))];

    this.setState({
      filterResult: result,
      filterType: target,
      availableFilters,
      pickedTypeFilter: target,
      pickedTagFilter: "all",
    });
  };

  openProject = (project) => {
    this.props.history.push(`/project/${project.id}`);
  };

  closeCarousel = () => {
    this.setState({ showModal: false, activeProjectImages: [] });
  };

  renderArrowPrev = (onClickHandler, hasPrev, label) =>
    hasPrev && (
      <button className="carousel-arrow prev" onClick={onClickHandler}>
        &lt;
      </button>
    );
  
  renderArrowNext = (onClickHandler, hasNext, label) =>
    hasNext && (
      <button className="carousel-arrow next" onClick={onClickHandler}>
        &gt;
      </button>
    );

    componentDidMount() {
      this.filterGallery("all");
      document.addEventListener("keydown", this.handleKeyPress);
    }
    
    componentWillUnmount() {
      document.removeEventListener("keydown", this.handleKeyPress);
    }
    
    handleKeyPress = (event) => {
      if (event.key === "Escape") {
        this.closeCarousel();
      }
    };
    
    handleClickOutside = (event) => {
      if (event.target.classList.contains("modal")) {
        this.closeCarousel();
      }
    };
  

  render() {
    const portfolioBreakpoints = {
      default: 3,
      1100: 3,
      700: 2,
      500: 1,
    };

    const projectsRender = this.state.filterResult?.map((project) => (
      <div key={project.id} onClick={() => this.openProject(project)}>
        <ProjectBox modelType={project.modelType} preview={project.preview} title={project.title} tag={project.tag} />
      </div>
    ));

    return (
      <div id="portfolio">
        <div className="wrapper">
          <Title title="WORK SHOWCASE." />
          <Row display="flex" style={{ marginBottom: "30px", justifyContent: "center" }}>
            <Col xs={12} sm={12} md={8} lg={9} style={{ justifyContent: "center", zIndex: 99999 }}>
              <div className="portfolio__nav">
                <ul style={{ justifyContent: "center", alignContent:"center",  height: "50px" }}>
                  <li
                    className={this.state.pickedTypeFilter === "all" ? "portfolio__nav-active font12" : "font12"}
                    style={{ alignItems: "center", alignContent: "center", fontSize: "15px" }}
                    onClick={() => this.filterGalleryBytYPE("all")}
                  >
                    ALL
                  </li>
                  <li
                    className={this.state.pickedTypeFilter === "ar" ? "portfolio__nav-active font12" : "font12"}
                    style={{ alignItems: "center", alignContent: "center", fontSize: "15px" }}
                    onClick={() => this.filterGalleryBytYPE("ar")}
                  >
                    AR
                  </li>
                  <li
                    className={this.state.pickedTypeFilter === "image" ? "portfolio__nav-active font12" : "font12"}
                    style={{ alignItems: "center", alignContent: "center", fontSize: "15px" }}
                    onClick={() => this.filterGalleryBytYPE("image")}
                  >
                    IMAGES
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={12} md={8} lg={9}>
              <div className="portfolio__nav">
                <ul>
                  {this.state.availableFilters.map((filter) => (
                    <li
                      key={filter}
                      className={this.state.pickedTagFilter === filter ? "portfolio__nav-active font12" : "font12"}
                      onClick={() => this.filterGallery(filter)}
                    >
                      {filter.toUpperCase()}
                    </li>
                  ))}
                </ul>
              </div>
            </Col>
          </Row>
          <Masonry
            breakpointCols={portfolioBreakpoints}
            className="my-masonry-grid"
            columnClassName="mint__gallery"
          >
            {projectsRender}
          </Masonry>

          {this.state.showModal && (
            <div className="modal">
              <div className="modal-content">
                <button onClick={this.closeCarousel} className="close-button" style={{ zIndex: 9999, fontSize: "25px" }}>
                  X
                </button>
                <Carousel
                  renderArrowPrev={this.renderArrowPrev}
                  renderArrowNext={this.renderArrowNext}
                  emulateTouch={true}
                  useKeyboardArrows={true}
                  showStatus={false}
                >
                  {this.state.activeProjectImages.map((image, index) => (
                    <div key={index}>
                      <img src={image} alt={`Project Slide ${index}`} />
                    </div>
                  ))}
                </Carousel>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(Portfolio);